import gql from 'graphql-tag';

const GET_OUTCOMES = gql`
  query outcomeReasonTypes($limit: Int, $skip: Int, $query: JSON, $patient_id: Int) {
    outcomeReasonTypes(limit: $limit, skip: $skip, query: $query, patient_id: $patient_id) {
      data {
        id
        outcome
        outcome_reason
        enroll_status
      }
    }
  }
`;

export default GET_OUTCOMES;
